module.exports = __webpack_public_path__ + "img/livepen-small.1736810e.png";